import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';
import AlertContactsDataGrid from '../components/alerts/AlertContactsDataGrid.tsx';

export default function AlertContacts() {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: '0 1.5rem 2.5rem', width: '100%', boxSizing: 'border-box' }}>

      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => navigate('/alerts')}
          startIcon={<ArrowBackIcon sx={{ fontSize: '14px !important', padding: '0 !important' }} />}
          sx={{
            fontFamily: "'DM Mono', monospace",
            fontSize: 11,
            textTransform: 'uppercase',
            color: 'var(--color-text-secondary)',
            borderColor: 'rgba(255,255,255,0.12)',
            borderRadius: 2,
            '&:hover': { borderColor: '#1D9E75', color: '#1D9E75' },
          }}
        >
          Back
        </Button>
        <Typography sx={{
          fontFamily: "'Syne', sans-serif",
          fontSize: 20,
          fontWeight: 600,
          color: '#1D9E75',
        }}>
          Contact Points
        </Typography>
      </Box>

      {/* Grid */}
      <Box sx={{ background: 'var(--color-bg-secondary)', borderRadius: 3, p: '1.25rem' }}>
        <AlertContactsDataGrid />
      </Box>
    </Box>
  );
}
